import "./Switch.scss";
import React from "react";
import { useDispatch } from "react-redux";

const Switch = React.memo((props) => {
  const dispatch = useDispatch();
  return (
    <div className="SwitchContainer">
      <label className="switch">
        <input
          type="checkbox"
          checked={props.value}
          onChange={(e) => dispatch(props.action)}
        />
        <div className="slider"></div>
      </label>
    </div>
  );
});

export default Switch;
